
import { FC, useContext, useEffect, useState } from "react"
import { DownloadReportsResponseTypeApi, StatsReportProps } from "./types";
import useFetch from "src/hooks/useFetch";
// import { DownloadZipErrorType } from "src/pages/dashboard/types";
// import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
// import { useNavigate } from "react-router-dom";
import { AuthContext } from "src/context/authContext";
import { LoaderContext } from "src/context/loaderContext";
// import { ToastContext } from "src/context/toastContext";
import { downloadExcelFile } from "src/helpers/downloadFile";

const StatsReports: FC<StatsReportProps> = ({ getValues, role }): JSX.Element => {
  const [enabledButton, setEnabledButton] = useState<boolean>(false);

  const { userData } = useContext(AuthContext)
  const { setLoader, hideLoader } = useContext(LoaderContext);




  const {
    data: downloadReportsData, error: downloadReportsError, mutate: downloadRequestForm,
    removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadReportsResponseTypeApi>(APIEndpoints.MANUFACTURE_STATISTICS_REPORT_DOWNLOAD);

  useEffect(() => {
    if (downloadReportsData || downloadReportsError) {
      if (downloadReportsData) {
        const { response, report_name } = downloadReportsData;
        downloadExcelFile(response, `${report_name}.xlsx`);
      }

      hideLoader()
      setEnabledButton(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadReportsData, downloadReportsError]);

  const downloadReport = (reportName: string) => {
    if (getValues) {
      let params = {
        'start_date': getValues().start_date,
        'end_date': getValues().end_date,
        'report_name': reportName,
        role: role,
        user_id: getValues().user_id || (userData ? userData.id.toString() : ""),
        // ...(userData && userData.ref_type === "rep" ? { user_id: userData.id } : {})
      }
      if (downloadReportsData || downloadReportsError) clearRequestFileData();

      setLoader();
      setEnabledButton(true)
      downloadRequestForm({}, {}, params);
    }
  }




  return (
    <div className="row g-2">
      {enabledButton ? (
        <div className="col">
          <p className="text-dark h5">
            <span className="spinner-border spinner-border-sm" style={{ width: 20, height: 20 }} aria-hidden="true"></span>{' '}
            <i>Fetching Report</i>
          </p>
        </div>)
        :

        userData?.ref_type === "Manufacturer" ?
          (<><div className="col-12 col-sm-4">
            <button
              className="btn btn-success w-100"
              onClick={() => downloadReport("detail_report")}
            >
              Detail Report
            </button>
          </div>

            <div className="col-12 col-sm-4">
              <button
                className="btn btn-success w-100"
                onClick={() => downloadReport("full_report")}
              >
                Full Report
              </button>
            </div>

            <div className="col-12 col-sm-4">
              <button
                className="btn btn-success w-100"
                onClick={() => downloadReport("plan_report")}
              >
                Plan Report
              </button>
            </div>
          </>)
          :
          (<> <div className="col-12 col-sm-4">
            <button
              className="btn btn-success w-100"
              onClick={() => downloadReport("detail_report")}
            >
              Detail Report
            </button>
          </div>

            <div className="col-12 col-sm-4">
              <button
                className="btn btn-success w-100"
                onClick={() => downloadReport("full_report")}
              >
                Full Report
              </button>
            </div>
          </>)
      }
    </div>
  )
}

export default StatsReports;
